import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { THEME_COLORS } from "../../utils/Constants";
import FbLoading from "../../assets/images/fbLoading.gif";
import { Dialog, DialogContent, Button } from "@material-ui/core";

const styles = theme => ({
  Root: {
    maxWidth: "300px",
    padding: "15px",
    textAlign: "center",
    backgroundColor: "rgba(0,0,0,0.9)"
  },
  Title: { margin: "0px", color: "white", fontSize: "30px" },
  P1: { margin: "0px", marginTop: "10px", color: "white", fontSize: "16px" },
  P2: { margin: "0px", color: "white", fontSize: "18px" },
  P3: {
    margin: "0px",
    color: "white",
    fontSize: "17px",
    color: "#F37020",
    fontWeight: "bold",
    marginTop: "2px"
  },
  Line: {
    margin: "15px 30px",
    backgroundColor: "white",
    height: "1px"
  },
  FeedbackBtn: {
    color: "white",
    borderRadius: "50px",
    padding: "10px 30px",
    fontSize: "14px",
    textTransform: "none",
    minHeight: "0px",
    borderColor: "white",
    "&:hover": {
      color: "white",
      backgroundColor: "#F37020",
      opacity: "0.9"
    }
  },
  SkipBtn: {
    color: "white",
    borderRadius: "50px",
    padding: "10px 30px",
    fontSize: "14px",
    textTransform: "none",
    minHeight: "0px",
    "&:hover": {
      color: "white",
      opacity: "0.9"
    }
  }
});

class FeedbackIntro extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, open, handleClose, itemInfo } = this.props;
    const { Root, Title, P1, P2, P3, Line, FeedbackBtn, SkipBtn } = classes;
    return (
      <Dialog
        open={open}
        scroll="paper"
        aria-labelledby="feedback intro"
        classes={{ paper: Root }}
      >
        <DialogContent>
          <h1 className={Title}>Can we make it better?</h1>
          <p className={P1}>
            Tell us how we can improve your cafeteria experience
          </p>
          <div className={Line} />
          <p className={P2}>Share your experience for</p>
          {itemInfo.length !== 0 && <br />}
          {itemInfo.map(data => {
            return <p className={P3}>{data}</p>;
          })}
        </DialogContent>
        <Button
          variant="outlined"
          block
          className={FeedbackBtn}
          onClick={() => handleClose({ state: false, open: true })}
        >
          Give Feedback
        </Button>
        <Button
          variant="outlined"
          className={SkipBtn}
          onClick={() => handleClose({ state: false, open: false })}
        >
          Skip
        </Button>
      </Dialog>
    );
  }
}

export default withStyles(styles)(FeedbackIntro);



// WEBPACK FOOTER //
// ./src/components/Utils/FeedbackIntro.js